//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 07.09.2015.
 */

(function () {

    'use strict';

    angular.module('container.components')
        .directive('srsngFileTable', srsngFileTable);

    function srsngFileTable() {

        return {
            restrict: 'A',
            scope: {},
            templateUrl: 'container/ui/app/components/file-table/file-table.html'
        };
    }
})();

